import React, { useState } from 'react';
import { action, observable, observer } from '@poa/state';
import EyeIcon from '../../icons/eye';
import LaddaButton, { SLIDE_UP, XL } from 'react-ladda';
import { env } from '../../../env';


class PasswordField extends React.Component {
  static defaultProps = {
    name: 'auth_password',
    placeholder: 'password'
  };

  isPasswordVisible = observable(false);

  togglePasswordVisibility = action(() =>
    this.isPasswordVisible.set(!this.isPasswordVisible.get())
  );

  render() {
    return (
      <div className='main-form__input main-form__pass'>
        <input
          {...this.props}
          type={this.isPasswordVisible.get() ? 'text' : 'password'}
          name={this.props.name}
          placeholder={this.props.placeholder}
          data-test-id={this.props.testId}
        />

        <button
          type='button'
          className='main-form__icon'
          onMouseDown={this.togglePasswordVisibility}
          onMouseUp={this.togglePasswordVisibility}
        >
          <EyeIcon />
        </button>
      </div>
    );
  }
}

PasswordField = observer(PasswordField);


const UserPassword = () => {

  const [oldPassword, setOlPassword] = useState('');
  const [newRepeatPassword, setNewRepeatPassword] = useState('');
  const [newPasswordValue, setNewPasswordValue] = useState('');
  const [passwordError, setPasswordError] = useState(null);

  return (
    <>
      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
        Смена пароля
      </div>

      <PasswordField
        name='oldPassword'
        placeholder='Старый пароль'
        value={oldPassword}
        onChange={e => {
          setOlPassword(e.target.value);
        }}
        onFocus={() => setPasswordError(null)}
      />

      <PasswordField
        name='newRepeatPassword'
        placeholder='Новый пароль'
        value={newPasswordValue}
        onChange={e => {
          setNewPasswordValue(e.target.value);
        }}
        onFocus={() => setPasswordError(null)}
      />

      <PasswordField
        name='oldPassword'
        placeholder='Повтор пароля'
        value={newRepeatPassword}
        onChange={e => {
          setNewRepeatPassword(e.target.value);
        }}
        onFocus={() => setPasswordError(null)}
      />

      {passwordError && <div className='profile-page__input--error'>{passwordError}</div>}

      <LaddaButton
        className='main-form__submit'
        type='submit'
        data-test-id='submitButton'
        data-color='#eee'
        data-size={XL}
        data-style={SLIDE_UP}
        data-spinner-size={30}
        data-spinner-color='#ddd'
        data-spinner-lines={12}
        onClick={() => {
          if (oldPassword === '' || newRepeatPassword === '' || newPasswordValue === '')
            return setPasswordError('Пожалуйста заполните все поля');
          if (newPasswordValue !== newRepeatPassword)
            return setPasswordError('Пароли не совпадают');
          env.http
            .post('staff/password/change/', {
              newPassword: newPasswordValue,
              oldPassword: oldPassword
            })
            .then(
              (response, reject) => {
                setNewPasswordValue('');
                setOlPassword('');
                setNewRepeatPassword('');
              },
              reject => {
                env.alert(
                  'Успех',
                  `Ошибка. Данные не сохранились. <br/>Обратитесь с администратору <br /><br /> Тип ошибки: ${reject}`
                );
              }
            );

          env.alert('Успех', `Данные успешно сохранены`);
        }}
      >
        Обновить пароль
      </LaddaButton>
    </>
  );
};

export default UserPassword;